import { Blockquote, Amazon, Twitter } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  Twitter,
  React
};